import styled from "styled-components";
import { formatCurrency } from "../../utils";
import { useContext } from "react";
import { AppContext } from "../../context";
import { Link } from "react-router-dom";

const StyledContainer = styled.section`
  width: 100%;
  height: auto;
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  column-gap: 20px;
`;

const StyledProductImage = styled.section`
  width: 100%;
  max-width: 200px;
  height: auto;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
  background-color: #d8d8d8;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
  }
`;

const StyledProductDetails = styled.section`
  flex: 1;
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  h3 {
    font-size: 20px;
    font-weight: 500;
    color: #000;
    margin: 0px;
    padding: 0px;
  }
  p {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    margin: 0px;
    padding: 0px;
  }
  h4 {
    font-size: 16px;
    font-weight: 500;
    color: green;
    margin: 0px;
    padding: 0px;
  }
`;

const StyledActionButtons = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px 0px 0px;
  button {
    width: auto;
    min-width: 100px;
    height: auto;
    border: 0px;
    outline: 0px;
    margin: 0px;
    padding: 10px 20px;
    font-size: 16px;
    color: #ffffff;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.5s ease;
    &:hover {
      transition: background-color 0.5s ease;
    }
    &.green {
      background-color: green;
      &:hover {
        background-color: #005d00;
      }
    }
    &.red {
      background-color: red;
      &:hover {
        background-color: #b00000;
      }
    }
  }

  a {
    width: auto;
    min-width: 100px;
    height: auto;
    border: 0px;
    outline: 0px;
    margin: 0px;
    padding: 10px 20px;
    font-size: 16px;
    color: #ffffff;
    border-radius: 5px;
    cursor: pointer;
    background-color: #0095ff;
    transition: background-color 0.5s ease;
    text-decoration: none;
    &:hover {
    background-color: #0079cf;
      transition: background-color 0.5s ease;
    }
`;

const ProductCard = ({
  id,
  productTitle,
  productDescription,
  photo,
  mrp,
  srp,
  alreadyInCart,
  addProduct,
  removeProduct,
}) => {
  const { isLoggedIn } = useContext(AppContext);

  return (
    <StyledContainer>
      <StyledProductImage>
        <img src={photo ? photo : "no-image.jpg"} alt={productTitle} />
      </StyledProductImage>
      <StyledProductDetails>
        <h3>{productTitle}</h3>
        <p>{productDescription}</p>
        <h4>{formatCurrency(srp ? srp : mrp)}</h4>
      </StyledProductDetails>
      <StyledActionButtons>
        {isLoggedIn ? (
          <button
            onClick={() => (alreadyInCart ? removeProduct(id) : addProduct(id))}
            className={alreadyInCart ? "red" : "green"}
          >
            {alreadyInCart ? "Remove" : "Add to Cart"}
          </button>
        ) : (
          <Link to={`/login?redirectUrl=${window.location.href}`} title="Login">
            Login to Order
          </Link>
        )}
      </StyledActionButtons>
    </StyledContainer>
  );
};

export default ProductCard;
